<template>
	<div v-if="displayDataEdit">
		<b-button
			v-if="!mode"
			v-b-toggle="className"
			block
			class="panel-item-header-button"
		>
			<div style="display: flex">
				<span class="panel-item-header-trigger-icon" />
				<span class="panel-item-header-title">
					<h5> {{ displayDataEdit.name || "No unit type name" }} </h5> 
				</span>
			</div>
		</b-button>

		<b-collapse :id="className" v-model="visible">
			<b-container>
				<b-row v-if="!mode"> 
					<b-col>
						<b>Description</b>
					</b-col>
				</b-row>

				<b-row v-if="!mode"> 
					<b-col>
						{{ displayDataEdit.description || 'No description' }}
					</b-col>
				</b-row>

				<b-row v-if="mode">
					<b-col>
						Name
						<b-form-input
							v-model="displayDataEdit.name"
							placeholder="Enter name"
						/>
					</b-col>
				</b-row>

				<b-row v-if="mode"> 
					<b-col>
						Description
						<b-form-textarea
							id="input-description"
							v-model="displayDataEdit.description"
							size="sm"
							placeholder="Enter description"
						/>
					</b-col>
				</b-row>

				<b-row>
					<b-col style="height: 15px" />
				</b-row>

				<b-row>
					<b-col>
						<h5> Configuration </h5>
					</b-col>
					<b-col>
						<b-form-datepicker
							v-if="mode"
							:id="'datepicker_' + index"
							v-model="displayDataEdit.asOfDate"
							size="sm" 
							locale="en" 
							placeholder="Choose a date"
							:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
						/>
						<b-icon 
							v-if="!mode"
							v-b-tooltip.hover.top="formatDate(displayDataEdit.asOfDate)"
							icon="clock"
							style="margin-bottom: 0.7rem !important;float: right;"
						/>
					</b-col>
				</b-row>

				<b-row>
					<b-col>
						<b> Area </b>
					</b-col>
				</b-row>

				<b-row>
					<b-col>
						<field-input
							v-model="displayDataEdit.averageArea"
							:mode="mode"
							:step="0.01"
							label="Average"
							unit="ft.^2"
						/>
					</b-col>
				</b-row>

				<b-row>
					<b-col>
						<field-input
							v-model="displayDataEdit.maximumArea"
							:mode="mode"
							:step="0.01"
							label="Maximum"
							unit="ft.^2"
						/>
					</b-col>
					<b-col>
						<field-input
							v-model="displayDataEdit.minimumArea"
							:mode="mode"
							:step="0.01"
							label="Minimum"
							unit="ft.^2"
						/>
					</b-col>
				</b-row>

				<b-row>
					<b-col>
						<b> Units </b>
					</b-col>
				</b-row>

				<b-row>
					<b-col>
						<field-input
							v-model="displayDataEdit.count"
							:mode="mode"
							:step="0.01"
							label="Count"
						/>
					</b-col>
					<b-col>
						<field-input
							v-model="displayDataEdit.pctOfProgram"
							:mode="mode"
							:step="0.01"
							label="% of Program Units"
						/>
					</b-col>
				</b-row>

				<b-row>
					<b-col style="height: 15px" />
				</b-row>

				<b-row>
					<b-col>
						<b-button
							v-if="mode"
							block
							style="background-color: #FFAAAA; color: #000000;"
							@click="remove()"
						>
							Remove Unit Type
						</b-button>
					</b-col>
				</b-row>
			</b-container>
		</b-collapse>
	</div>
</template>

<script>
export default {
    name: 'UnitTypeView',
	components: {},
    filters: {},
	props: {
        unittype: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true
        },
        mode: {
            type: Boolean,
            required: true
        }
	},   
    data() {
        return {
            className: '',
			displayDataEdit: {},
			visible: false
        }
    },
    computed: {
		formatDate() {
			return date => (!date || date === '') ? `Not updated`: new Intl.DateTimeFormat('en-US', { dateStyle: 'long' }).format(new Date(date.replace(/-/g, '/').replace(/T.+/, ''))) 
		}
	},
    watch: {
		displayDataEdit: {
			deep: true,
			handler() {
				this.updateData();
			},
		},
		unittype: {
			immediate: true,
			handler(newVal) {
				this.displayDataEdit = newVal;
			},
		},
		mode: {
			immediate: true,
			handler(newVal) {
				if (newVal) this.visible = newVal;
			},
		},
        index: {
			immediate: true,
			handler(newVal) {
				this.className = `unittype_collapse_${newVal}`;
			},
		}
	},
	created() {
	},
    mounted() {
	},
    methods: {
		async updateData() {
			if (this.displayDataEdit && this.displayDataEdit.id) {
				const updateUnitTypeModelData = await this.axios.patch(
					`/unittypes/${this.displayDataEdit.id}`,
					this.displayDataEdit
				);
			}
		},
		async remove() {
			if (this.displayDataEdit && this.displayDataEdit.id) {
				const deleteUnitTypeModelData = await this.axios.delete(
					`/unittypes/${this.displayDataEdit.id}`
				);
				this.$emit('remove', this.index);
			}
		}
    }
};
</script>

<style scoped>
.btn {
	border: none;
    outline: none;
}
.btn:focus {
    box-shadow: none;
	outline: none;
}
.btn:focus-visible {
    outline: 0;
    border-radius: 0;
}
.btn:hover {
    color: #fff;
    text-decoration: none;
}
.btn-secondary {
	border: none;
    outline: none;
}
.btn-secondary:focus {
    background-color: transparent;
    border-color: transparent;
    box-shadow: none;
	outline: 0;
}
.btn-secondary:hover {
    color: #fff;
    background-color: transparent;
    border-color: transparent;
	outline: none;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
    color: #fff;
    background-color: transparent;
    border-color: transparent;
	outline: none;
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
    box-shadow: none;
}
.btn-secondary:focus-visible {
    outline: 0;
    border-radius: 0;
}
.panel-item-header-button {
    background-color: transparent;
}
.panel-item-header-title {
    bottom: 2px;
}
div.associated-phase {
    border-radius: 12px;
    border: 1px solid #000000;
    padding: 5px;
	background-color: #647882;
    color: #ffffff;
}
</style>

<style lang="scss">
</style>